var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RiskDistributionBody"},[_c('EmptyTip',{attrs:{"show":_vm.apiData.length == 0}}),_c('div',{staticClass:"riskBox"},_vm._l((_vm.reskDistributionValue),function(item,index){return _c('div',{key:index,staticClass:"risk",style:({
        height: item.count * 1.2 + 'px',
      }),on:{"click":function($event){return _vm.handleClickRisk(item)}}},[_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(item.tags_name))])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }